import Vue from 'vue';
import store from '../store';
import router from '../router';

import { APPACCESSTOKEN } from '../utils/const';

import { BASEURL, COMEINURL } from '../fetch/host';
import { webNative, getUserInfo } from '../utils/api';
import $axios from '@/axios';

const vue = new Vue({
	store,
	router
});

/** 订阅和取消订阅接口
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.eventid {String} 路演id
 * @param obj.isnotifi {String} 是否收藏（订阅）
 */
export const fetchEventAttentionEvent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_event_attentionevent',
		body: {
			eventid: obj.eventid,
			isnotifi: obj.isnotifi
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 获取分析师数据接口
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.characterid {String} 人物id
 */
export const fetchBannerCharacterDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_characterdetail',
		body: {
			characterid: String(obj.characterid)
		},
		success: res => {
			obj.success && obj.success(res);
		}
		// loading: true
	});
};

/** 获取分析师观点
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.characterid {String} 人物id
 *
 */
export const fetchBannerCharacterArticle = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_characterarticle',
		body: {
			characterid: String(obj.characterid),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**获取金牌分析师直播列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.characterid {String} 人物id
 */
export const fetchBannerCharacterEvent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_characterevent',
		body: {
			uc: vue.$bridge.bolUc ? vue.$bridge.uc : '',
			characterid: String(obj.characterid),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**获取金牌分析师回放列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.characterid {String} 人物id
 */
export const fetchBannerCharacterRecord = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_characterrecord',
		body: {
			characterid: String(obj.characterid),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**获取金牌分析师历史推荐股票
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.characterid {String} 人物id
 */
export const fetchAnalystRecommend = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_analyst_recommend',
		body: {
			characterid: String(obj.characterid),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: true
	});
};

/**获取金牌分析师本月推荐股票
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.characterid {String} 人物id
 */
export const fetchAnalystMonthlyRec = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_analyst_monthlyrec',
		body: {
			characterid: String(obj.characterid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: true
	});
};

/**金牌分析师页面关注或取关注其他用户
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.substatus {String} 关注或取消关注 ("1"：关注；"0"：取消关注）
 * @param obj.subuid {String} 被关注的用户ID
 */
export const fetchSubOtherUser = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_subotheruser',
		body: {
			substatus: String(obj.substatus),
			subuid: String(obj.subuid)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/**券商研究所获取专题信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} 专题id
 */
export const fetchBannerTopicDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topicdetail',
		body: {
			topicid: String(obj.topicid)
		},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

/**获取分析师列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} 专题id
 */
export const fetchBannerTopicAnalyst = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topicanalyst',
		body: {
			topicid: String(obj.topicid),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**关注或取关注其他用户
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.substatus {String} 关注或取消关注 ("1"：关注；"0"：取消关注）
 * @param obj.subuid {String} 被关注的用户ID
 */
export const fetchUserSubOtherUser = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_subotheruser',
		body: {
			substatus: String(obj.substatus),
			subuid: String(obj.subuid)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/**
 * 获取第三方：招商证券 研究所主页 宏观策略、专场列表数据
 * @param ctx
 * @param obj topicid 专题id
 * @param obj type 类型 1-公开行业,2-付费,专场类型,其他行业
 * */
export const fetchBannerTopicRoadshow = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topicroadshow',
		body: {
			topicid: String(obj.id),
			type: String(obj.type),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 券商观点列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchBannerTopicEvent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topicevent',
		body: {
			uc: vue.$bridge.bolUc ? vue.$bridge.uc : '',
			topicid: String(obj.topicid),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 券商观点列搜索
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 * @param obj.roadshowTitle {String} 路演关键字搜索
 */
export const fetchBannerTopicSearch = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topicevent',
		body: {
			uc: vue.$bridge.bolUc ? vue.$bridge.uc : '',
			topicid: String(obj.topicid),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15),
			roadshowTitle: String(obj.roadshowTitle)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 券商回放列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchBannerTopicRecord = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topicrecord',
		body: {
			topicid: String(obj.topicid),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 券商调研列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchBannerTopicResearch = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topicresearch',
		body: {
			topicid: String(obj.topicid),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 券商培训列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchBannerTopicCourse = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_topiccourse',
		body: {
			topicid: String(obj.topicid),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 分析师榜单列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.type {String} 榜单类型（0：荣耀榜；1：人气榜；2：实力榜）
 * @param obj.uid {String} 登录用户id
 */
export const fetchBannerAnalystRanking = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_banner_analystranking',
		body: {
			type: String(obj.type),
			date: obj.date
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: true
	});
};

/** 专场落地页详情
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.activityid {String} 专场id
 * @param obj.type {String} 专场类型
 */
export const fetchReferralPopularize = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_popularize_referrallinkinfo',
		body: {
			id: String(obj.id),
			roadshowId: String(obj.roadshowId),
			type: obj.type
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 专场落地页详情
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.activityid {String} 专场id
 * @param obj.type {String} 专场类型
 */
export const fetchSpecialPopularize = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_popularize_specialinfo',
		body: {
			id: String(obj.id),
			roadshowId: String(obj.roadshowId),
			type: obj.type
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 申请参会活动详情
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.activityid {String} 活动id
 */
export const fetchMeetingActivityDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_meetingactivity_detail',
		body: {
			activityid: String(obj.activityId)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: obj.loading || true,
		keepAllLine: true
	});
};

/** 虚拟手机号判断
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchUserIsTruePhone = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_is-true-phone',
		body: {
			userId: obj.uid,
			phone: obj.phone
		},
		success: res => {
			obj.success && obj.success(res);
		}
		// loading: true
	});
};

/** irm用户个人信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchIrmUserInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'irm_user_userdetail',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** irm活动报名获取用户个人信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchIrmActivityUserDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_irmactivitydetail',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 活动报名/约调研获取用户动态个人信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchUserDynamicInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_dynamicinfo',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
	// $axios.post(COMEINURL+'/json/user/dynamicinfo', {}).then(res => {
	// 	console.log("🚀 ~ $axios.post ~ res:", res)
	// 	obj.success && obj.success(res);
	// })
};

/** 用户投资类型列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchUserInvestTypeList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_investtypelist',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 投资者投资类型列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchInvestorInvestTypeList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_investtypelist',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 根据用户类型，查询机构表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchInvestorListbyuserinvesttype = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_list-by-user-invest-type',
		body: {
			userInvestType: String(obj.userInvestType),
			keyword: String(obj.keyword),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/** 根据用户类型，查询用户机构审核过的历史记录
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchInvestorListbyusercompanyhistory = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_list-by-user-company-history',
		body: {
			userInvestType: String(obj.userInvestType),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/** 根据记录ID删除用户历史记录信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchInvestorDeleteusercompanyhistory = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_delete-user-company-history',
		body: {
			id: String(obj.id)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 清空用户历史记录信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchInvestorClearusercompanyhistory = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_clear-user-company-history',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 行业类型列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchTagIndustryList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_tag_industry',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 用户机构投资者信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchInvestorInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_info',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 投资公司用户类型按名称匹配
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchInvestorCompanyTypeCheck = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_company-type-check',
		body: {
			company: obj.company || '',
			userinvesttype: obj.userinvesttype || -1
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 用户机构投资者提交认证
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchInvestorSubmitVerify = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_investor_submitverify',
		body: {
			name: String(obj.name),
			bcard: String(obj.bcard),
			userinvesttype: String(obj.userinvesttype),
			company: String(obj.company),
			occupation: String(obj.occupation),
			authcode: obj.authcode || '',
			reauthentication: obj.reauthentication || 0 // 审核过程中重新认证（0 否 1 是）
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, errordesc) => {
			obj.error && obj.error(code, errordesc);
		},
		loading: true
	});
};

/** 用户分析师研究所列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchOrganizationOrgList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_organization_org-list',
		body: {
			keyword: String(obj.keyword)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 用户分析师信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchAnalystsInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_analystauth_info',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 用户分析师提交认证
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchAnalystsSubmitVerify = (ctx, obj) => {
	let body = {
		name: String(obj.name),
		bcard: String(obj.bcard),
		industryIds: String(obj.industryIds),
		company: String(obj.company),
		professioncode: String(obj.professioncode),
		organizationId: String(obj.organizationId),
		brief: String(obj.brief),
		reauthentication: obj.reauthentication || 0 // 审核过程中重新认证（0 否 1 是）
	};
	if (obj.id) {
		body.recordId = obj.id;
	}
	comeinFetch({
		constant_key: 'json_analystauth_submit',
		body: body,
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc);
		},
		loading: true
	});
};

/** 用户上市公司高管信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchExecutivesInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_companymgr_info',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: false
	});
};

/** 用户上市公司高管提交认证
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchExecutivesSubmitVerify = (ctx, obj) => {
	let body = {
		name: String(obj.name),
		bcard: String(obj.bcard),
		company: String(obj.company),
		occupation: String(obj.occupation),
		reauthentication: obj.reauthentication || 0 // 审核过程中重新认证（0 否 1 是）
	};
	if (obj.id) {
		body.recordId = obj.id;
	}
	comeinFetch({
		constant_key: 'json_companymgr_submit',
		body: body,
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc);
		},
		loading: true
	});
};

/** 获取参会活动申请信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchMeetingActivityRecord = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_meetingactivity_record',
		body: {
			activityid: String(obj.activityId),
			supportReviewType: obj.supportReviewType
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 获取参会活动申请信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchSelfMeetingRecord = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_get-self-help-meet-enroll',
		body: {
			meetingId: String(obj.meetingId)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: e => {
			obj.error && obj.error(e);
		},
		loading: true
	});
};

/** 提交参会活动申请信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchSelfMeetingApply = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_submit-self-help-meet-enroll',
		body: {
			meetingId: String(obj.meetingId),
			name: obj.username,
			areaCode: obj.areaCode,
			phone: obj.phone,
			company: obj.company,
			position: obj.occupation,
			businessCard: obj.bcard,
			userType: String(obj.userinvesttype),
			issync: obj.issync || 0,
			supportReviewType: obj.supportReviewType,
			signPath: obj.signPath
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

/** 报名管理-取消报名
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param id {String} 报名id
 */
export const fetchCancelMeetingEnroll = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_cancel-meeting-enroll',
		body: {
			id: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

/** 自助会议申请参会-重新提交校验
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param id {String} 报名id
 */
export const fetchCheckMeetingEnroll = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_check-meeting-enroll',
		body: {
			id: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 提交参会活动申请信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchMeetingActivityApply = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_meetingactivity_apply',
		body: {
			activityid: String(obj.activityId),
			username: obj.username,
			company: obj.company,
			occupation: obj.occupation,
			bcard: obj.bcard,
			email: obj.email,
			userinvesttype: String(obj.userinvesttype),
			issync: obj.issync || 0,
			supportReviewType: obj.supportReviewType,
			signPath: obj.signPath,
			needCallOut: Number(obj.needCallOut) || 0,
			landAreaCode: obj.landAreaCode,
			regionalCode: obj.regionalCode,
			landlineNumber: obj.landlineNumber,
			reauthentication: obj.reauthentication || 0,
			customConditionInfoStr: obj.customConditionInfoStr,
			languageType: obj.languageType
		},
		success: res => {
			obj.success && obj.success(res);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		},
		loading: true
	});
};

/** 获取参会活动关联的直播厅
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.activityid {String} 活动id
 */
export const fetchMeetingActivityEvents = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_meetingactivity_events',
		body: {
			activityid: String(obj.activityid)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 参会，查询联系人名单列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.contactsid {String} 名单id
 */
export const fetchContactsDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_contacts_detail',
		body: {
			contactsid: String(obj.contactsid)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 搜索联系人名单
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.contactsid {String} 名单id
 * @param obj.keyword {String} 搜索关键字
 */
export const fetchContactsSearch = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_contacts_search',
		body: {
			contactsid: String(obj.contactsid),
			keyword: String(obj.keyword)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 用户身份校验
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.realname {String} 姓名
 * @param obj.identity {String} 身份证
 */
export const fetchUserIdVerify = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_idverify',
		body: {
			realname: String(obj.realname),
			identity: String(obj.identity)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 记录用户风险测评
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.score {String} 测评分数
 */
export const fetchUserRiskEval = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_riskeval',
		body: {
			score: String(obj.score)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 查询用户风险测评
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.score {String} 测评分数
 */
export const fetchUserRiskLevel = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_risklevel',
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

/** 获取实名认证信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchUserVerifyInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_verifyinfo',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 提交实名认证信息
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchUserVerify = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_verify',
		body: {
			name: String(obj.name),
			company: String(obj.company),
			occupation: String(obj.occupation),
			bcard: String(obj.bcard),
			userinvesttype: String(obj.userinvesttype)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 名片识别
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchUserCardReCog = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_user_cardrecog',
		body: {
			bcard: String(obj.bcard)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		}
		// ,
		// loading: true
	});
};

/** 调研活动列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchResearchList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_list',
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 调研活动详情
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchResearchDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_detail',
		body: {
			activityid: String(obj.activityid)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 调研活动报名
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchResearchSign = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_sign',
		body: {
			activityid: String(obj.activityid)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 调研活动报名用户详情
 *	http://yapi.comein.cn/project/106/interface/api/32114
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchResearchSignupInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_signup-info',
		body: {
			activityId: String(obj.activityId)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 课程简介
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.cid {String} 课程id
 *
 */
export const fetchClassSummary = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_summary',
		body: {
			eventid: String(obj.eid),
			cid: String(obj.cid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 课程目录
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.cid {String} 课程id
 *
 */
export const fetchClassContent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_content',
		body: {
			cid: String(obj.cid)
		},
		success: res => {
			obj.success && obj.success(res);
		},
		loading: true
	});
};

/** 课程评论列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.cid {String} 课程id
 *
 */
export const fetchClassComment = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_comment',
		body: {
			cid: String(obj.cid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 课程评论
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.cid {String} 课程id
 * @param obj.star {String} 星级（1-5）
 * @param obj.content {String} 评论内容
 *
 */
export const fetchClassMakeComment = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_makecomment',
		body: {
			cid: String(obj.cid),
			star: String(obj.star),
			content: String(obj.content)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc) => {
			if (obj.error) {
				obj.error(code, desc);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		}
	});
};

/** 课程关联路演列表
 *
 * @param ctx store 实例
 * @param obj { Object } 参数对象
 * @param obj.cid { String } 课程id
 * @param obj.pagestart { String } 页码
 * @param obj.pagenum { String } 页条数
 */
export const fetchClassRoadshowList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_class_roadshowlist',
		body: {
			cid: String(obj.cid),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
export const fetchRoadshowPasswordFormat = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_self_share',
		body: {
			meetingId: String(obj.id),
			type: String(obj.type)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**
 * 请求富媒体html
 * @param obj.url {String} 请求地址
 * @param obj.Success {Function} 返回成功的回调
 */
export const requestRichMedia = (ctx, obj) => {
	vue.$http.get(obj.url, { timeout: 0 }).then(res => {
		const body = res.data;
		const detailContentIndex = body.indexOf('<body>');
		const bodyLabelIndex = body.indexOf('</body>');
		const html = body.substring(detailContentIndex, bodyLabelIndex);
		obj.success && obj.success(html || body);
	});
	/*.catch(err => {
        if (obj.error) {
            obj.error(err);
        } else {
            ctx.dispatch("showTooltip", {
                msg: "获取内容失败"
        })
        }
    });*/
};

/**
 * 股票资讯接口
 * @param obj.url {String} 请求地址
 * @param obj.stockid {String} 股票id
 * @param obj.pagestart {String} 起始页，默认0
 * @param obj.pagenum {String} 每页个数，默认10
 *
 */
export const fetchStockMessage = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_stock_message',
		access: APPACCESSTOKEN,
		body: {
			fullcode: String(obj.fullcode),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		code_201: true,
		error: (code, desc) => {
			if (code === '201') {
				top.location.href = '/mobile/login';
			}
		},
		loading: false
	});
};

/**
 * 股票资讯接口（行情）
 * @param obj.url {String} 请求地址
 * @param obj.stockid {String} 股票id
 * @param obj.pagestart {String} 起始页，默认0
 * @param obj.pagenum {String} 每页个数，默认10
 *
 */
export const fetchStockMessageForHS = (ctx, obj) => {
	Vue.axios.post(BASEURL, obj.param).then(res => {
		if (res.data.errorcode === '201') {
			top.location.href = '/mobile/login';
		} else if (res.data.data) {
			obj.success && obj.success(res.data.data, res.data.extra);
		}
	});
};

/**
 * 股票咨询互动接口（行情）
 * @param obj.url {String} 请求地址
 * @param obj.stockid {String} 股票id
 * @param obj.pagestart {String} 起始页，默认0
 * @param obj.pagenum {String} 每页个数，默认10
 * @author hcy
 */
export const fetchStockAdvisories = (ctx, obj) => {
	// Vue.axios.post(BASEURL, obj.param)
	// 	.then(res => {
	// 		if(res.data.errorcode === '201') {
	// 			top.location.href = '/mobile/login';
	// 		}else if(res.data.data) {
	// 			obj.success && obj.success(res.data.data, res.data.extra)
	// 		}else{
	// 			obj.error && obj.error(res);
	// 		}
	// 	})
	comeinFetch({
		constant_key: obj.param.app + '_' + obj.param.mod + '_' + obj.param.act,
		body: {
			fullcode: obj.param.fullcode,
			pageStart: obj.param.pageStart,
			pagenum: obj.param.pageNum
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: true
	});
};

/**
 * 直播回放详情
 * @param obj.rid {String} 回放id
 *
 */
export const fetchRecordBrief = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_record_brief',
		body: {
			rid: String(obj.rid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: true
	});
};

/**
 * 获取路演状态
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchEventNoticePageStatus = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_event_noticepagestatus',
		body: {
			eventid: String(obj.eid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			if (code === '1300') {
				location.replace(location.origin + `/mobile/404?errorcode=${code}`);
			}
		},
		loading: false
	});
};

/**
 * 路演预告内容
 * @param ctx {String} store实例
 * @param obj {Object} roadshowid 路演id
 */
export const fetchRoadshowNoticePageContent = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_noticepagecontent',
		body: {
			roadshowid: String(obj.id)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 预约路演/取消预约
 * @param {*} ctx
 * @param {*} obj
 */
export const fetchRoadshowSubscript = (ctx, obj) => {
	return new Promise((resolve, reject) => {
		comeinFetch({
			constant_key: 'json_roadshow_appointment',
			body: {
				roadshowid: obj.id,
				status: obj.status
			},
			success: (res, extra) => {
				obj.success && obj.success(res, extra);
				resolve(res, extra);
			},
			error() {
				reject(arguments);
			},
			loading: false
		});
	});
};

/**
 * 获取路演文档权限
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchEventNoticePageAuth = (ctx, obj) => {
	comeinFetch({
		code_450: true,
		constant_key: 'json_event_noticepageauth',
		body: {
			eventid: String(obj.eid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			} else {
				ctx.dispatch('showTooltip', {
					msg: desc
				});
			}
		},
		loading: false
	});
};

/**
 * 获取路演文档
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 */
export const fetchEventNoticePageDocument = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_event_noticepagedocument',
		body: {
			eventid: String(obj.eid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 获取路演提问数量
 * @param ctx {String} store实例
 * @param obj.reviewstatus {int} 审核状态 1审核通过 2审核不通过 查询演播厅内（所有用户的问答列表界面）的问答需传入reviewstatus=1，只查询审核状态为通过的问答
 * @param obj.roadshowid {long} 路演id
 * @param obj.queryUid {long} 如果是查询我的问答（普通用户）的新增问答需传入该值
 * @param obj.timestamp {long} 时间戳，查询当前时间戳新增的问答个数 不传则显示所有数量
 */
export const fetchQuestionCount = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_question_questioncount',
		body: {
			roadshowid: Number(obj.roadshowid),
			reviewstatus: 1 //1审核通过 2审核不通过 不传取全部
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: code => {
			obj.error && obj.error(code);
		},
		loading: false
	});
};

/**
 * 获取路演提问列表
 * @param ctx {String} store实例
 * @param obj.roadshowid {long} 路演id
 * @param obj.pagestart {String} 起始页，默认0
 * @param obj.pagenum {String} 每页个数，默认10
 */
export const fetchQuestionListbyrid = (ctx, obj) => {
	comeinFetch({
		code_450: obj.code_450,
		constant_key: 'json_question_listbyrid',
		body: {
			roadshowid: Number(obj.roadshowid),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: code => {
			obj.error && obj.error(code);
		},
		loading: false
	});
};

/**
 * 路演提问-获取我的提问
 * @param ctx {String} store实例
 * @param obj.roadshowid {long} 路演id
 * @param obj.pagestart {String} 起始页，默认0
 * @param obj.pagenum {String} 每页个数，默认10
 */
export const fetchQuestionListbyuid = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_question_listbyuid',
		body: {
			roadshowid: Number(obj.roadshowid),
			pagestart: String(obj.pagestart),
			pagenum: String(obj.pagenum)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 路演提问-添加提问
 * @param ctx {String} store实例
 * @param obj.roadshowid {long} 路演id
 * @param obj.content {String} 提问内容
 * @param obj.verify {String} 私密路演的密码
 */
export const fetchQuestionNew = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_question_new',
		body: {
			roadshowid: Number(obj.roadshowid),
			content: String(obj.content),
			verify: String(obj.verify)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			ctx.dispatch('showTooltip', { msg: desc });
			obj.error && obj.error(code, desc);
		},
		loading: true
	});
};

/**
 * 路演提问-删除提问
 * @param ctx {String} store实例
 * @param obj.questionid {long} 问题id
 */
export const fetchQuestionDel = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_question_del',
		body: {
			questionid: Number(obj.questionid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 路演手签
 * @param ctx {String} store实例
 * @param obj.id {long} 路演ID
 * @param obj.signPath {String} 手签图片地址
 */
export const fetchRoadshowSign = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_sign',
		body: {
			roadshowId: Number(obj.id),
			signPath: obj.signPath
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			ctx.dispatch('showTooltip', { msg: desc });
			obj.error && obj.error(code, desc);
		},
		loading: false
	});
};

/**
 * 恒生接口获取数据
 * @param ctx {String} store实例
 * @param obj {Object} url, param, success, error
 */
export const fetchHSInterface = (ctx, obj) => {
	/* 采用 post 请求是为了兼容 axios 的拦截第三方 HOST 的BUG */
	$.post(obj.url, obj.param)
		.done(res => {
			/* 兼容 接口返回字段 数据类型 有时为 json 字符串，有时为 Obj */
			res = typeof res === 'string' ? JSON.parse(res) : res;
			res && obj.success && obj.success(res.data);
		})
		.fail(err => {
			if (err && err.status && err.status === 401) {
				let param = {
					app: 'json',
					mod: 'market',
					act: 'gettoken',
					isverify: '0',
					ipotoken: localStorage.getItem('HS_share_token')
				};
				$.post(BASEURL, param).done(res => {
					if (!Number(res.errorcode)) {
						localStorage.setItem('HS_trading_token', res.data.margintrading);
						localStorage.setItem('HS_market_token', res.data.realtime);
						localStorage.setItem('HS_share_token', res.data.ipo);
						/* 回调一个res 对象 */
						obj.error && obj.error(err.data);
					} else {
						ctx.dispatch('showTooltip', { msg: res.errordesc });
					}
				});
			}
		});
};

/**
 * 根据类型获取股票列表(行情)
 * @param ctx {String} store实例
 * @param obj {Object} 对应参数
 */
export const fetchMarketMarketStockByTypeList = (ctx, obj) => {
	let body = {};
	if (obj.marketvalue) {
		body.marketvalue = String(obj.marketvalue);
	} else if (obj.booktomarket) {
		body.booktomarket = String(obj.booktomarket);
	} else if (obj.momentum) {
		body.momentum = String(obj.momentum);
	}
	body.tradingyear = String(obj.tradingyear);
	body.pagestart = String(obj.pagestart);
	body.pagenum = String(obj.pagenum);
	comeinFetch({
		constant_key: 'json_market_marketstockbytypelist',
		body,
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 根据类型获取股票列表(行情)
 * @param ctx {String} store实例
 * @param obj {Object} 对应参数
 */
export const fetchStockInfo = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_stock_baseinfo',
		access: APPACCESSTOKEN,
		body: {
			fullcode: String(obj.fullcode)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 根据类型获取股票列表(行情-恒生嵌入)
 * @param ctx {String} store实例
 * @param obj {Object} 对应参数
 */
export const fetchStockInfoForHS = (ctx, obj) => {
	/*	comeinFetch({
            constant_key: 'json_stock_baseinfo',
            access: APPACCESSTOKEN,
            body: {
                fullcode: String(obj.fullcode),
            },
            success: (res, extra) => {
                obj.success && obj.success(res, extra)
            },
            loading: false
        })*/

	Vue.axios.post(BASEURL, obj.param).then(res => {
		if (res.data.errorcode === '201') {
			top.location.href = '/mobile/login';
		} else if (res.data.data) {
			obj.success && obj.success(res.data.data, res.data.extra);
		}
	});
};

export const fetchStockHSData = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_stockinfo',
		body: {
			orgId: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (...args) => {
			obj.error && obj.error(...args);
		},
		loading: false
	});
};

export const fetchMarketGetToken = (ctx, { v, success }) => {
	getToken();

	function getToken() {
		// const val = getCookie(v)
		const val = localStorage.getItem(v);

		if (!val) {
			setTimeout(() => {
				getToken();
			}, 10);
		} else {
			success && success(val);
		}
	}
};

/*export const fetchMarketGetToken = (ctx, {v, success}) => {
	Vue.axios.post(BASEURL, {v, success})
		.then(() => {
			getToken();
			function getToken() {
				const val = getCookie(v);
				if (!val) {
					setTimeout(() => {
						getToken()
					}, 10)
				} else {
					success && success(val)
				}
			}
		})
};*/

/**
 * 行情请求分析师下面行业相关路演回放列表
 * @param: (String) subjectid id
 * @param: (String) type 类型 ('0':文章，'1': 股票)
 * @param: (String) pagestart 起始页
 * **/
export const fetchStockRecRoadShowList = (ctx, obj) => {
	let body = {};
	if (obj.subjectid) {
		body.subjectid = obj.subjectid;
	} else if (obj.fullcode) {
		body.fullcode = obj.fullcode;
	}
	body.type = obj.type;
	body.pagestart = obj.pagestart;
	obj.pagenum && (body.pagenum = obj.pagenum);
	comeinFetch({
		constant_key: 'json_stock_recroadshowlist',
		access: APPACCESSTOKEN,
		body,
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		code_201: true,
		error: (code, desc) => {
			if (code === '201') {
				top.location.href = '/mobile/login';
			}
		},
		loading: false
	});
};

/**
 * 行情请求分析师下面行业相关路演回放列表(行情)
 * @param: (String) subjectid id
 * @param: (String) type 类型 ('0':文章，'1': 股票)
 * @param: (String) pagestart 起始页
 * **/
export const fetchStockRecRoadShowListForHS = (ctx, obj) => {
	Vue.axios.post(BASEURL, obj.param).then(res => {
		if (res.data.errorcode === '201') {
			top.location.href = '/mobile/login';
		} else if (res.data.data) {
			obj.success && obj.success(res.data.data, res.data.extra);
		}
	});
};

/**
 * 关注股票，用于嵌入行情恒生页面 功能同 fetchSubscription，只是错误处理不同
 * @param: (String) contentid id
 * @param: (String) contenttype 类型 ('6':股票 '7':专题)
 * @param: (String) operate 订阅/取消订阅 ('1':添加关注，'0':取消关注)
 * **/
export const fetchSubscription = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_subscription_operate',
		access: APPACCESSTOKEN,
		body: {
			contentid: obj.contentid,
			contenttype: obj.contenttype,
			operate: obj.operate,
			topictype: obj.topictype
		},
		success: res => {
			obj.success && obj.success(res);
		},
		code_201: true,
		error: (code, desc) => {
			if (code === '201') {
				top.location.href = '/mobile/login';
			}
		},
		loading: false
	});
};

/**
 * 关注股票，用于嵌入行情恒生页面 功能同 fetchSubscription，只是错误处理不同
 * @param: (String) contentid id
 * @param: (String) contenttype 类型 ('6':股票 '7':专题)
 * @param: (String) operate 订阅/取消订阅 ('1':添加关注，'0':取消关注)
 * **/
export const fetchSubscriptionForHS = (ctx, obj) => {
	Vue.axios.post(BASEURL, obj.param).then(res => {
		if (res.data.errorcode === '201') {
			top.location.href = '/mobile/login';
		} else if (res.data.data) {
			obj.success && obj.success(res.data.data, res.data.extra);
		}
	});
};

/**
 * 查询股票相关的分析师（行情Tab）
 * @param context {String} store实例
 * @param obj {Object} 对应参数
 */
export const fetchStockCharacterForHS = (context, obj) => {
	Vue.axios.post(BASEURL, obj.param).then(res => {
		if (res.data.errorcode === '201') {
			top.location.href = '/mobile/login';
		} else if (res.data.data) {
			obj.success && obj.success(res.data.data, res.data.extra);
		}
	});
};

/**
 * 我的服务，投研秘书，金融课堂列表
 * @param context {String} store实例
 * @param obj {Object} 对应参数
 * @param obj ordertype:2为金融课堂，6为投研秘书 , 7专栏 8路演
 */
export const fetchUserServices = (context, obj) => {
	comeinFetch({
		constant_key: 'json_user_services',
		body: {
			ordertype: String(obj.ordertype),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**
 * 调研列表
 * @param context {String} store实例
 * @param obj {Object} 对应参数
 */
export const fetchGetEnrollments = (context, obj) => {
	comeinFetch({
		constant_key: 'json_conference_offlines',
		body: {
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 20)
		},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};
/**
 * 我的调研列表
 * @param context {String} store实例
 * @param obj {Object} 对应参数
 */
export const fetchUserEnrollments = (context, obj) => {
	comeinFetch({
		constant_key: 'irm_register_registers',
		body: {
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/**
 * 我的约调研列表
 * @param context {String} store实例
 * @param obj {Object} 对应参数
 */
export const fetchUserAppoints = (context, obj) => {
	comeinFetch({
		constant_key: 'json_research_asklist',
		body: {
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**
 * 我的身份认证列表
 * @param context {String} store实例
 * @param obj {Object} 对应参数
 */
export const fetchUserAuthList = (context, obj) => {
	comeinFetch({
		constant_key: 'json_auth_status',
		body: {},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**
 * 约调研详情
 * @param context {String} store实例
 * @param recordId {Object} 对应参数
 */
export const fetchIrmAppointDetail = (context, obj) => {
	comeinFetch({
		constant_key: 'json_research_askdetail',
		body: {
			recordId: obj.id
		},
		success: res => {
			obj.success && obj.success(res);
		}
	});
};

/**
 * pc 登录请求二维码
 * @param context {Object} store实例
 * @param obj {Object} 对应参数
 */
export const fetchQRCodeLogin = (context, obj) => {
	comeinFetch({
		url: '/irmuser/irm/user/qrCodeLogin',
		body: {
			type: String(obj.type),
			uuid: String(obj.uuid)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: code => {
			obj.error && obj.error(code);
		},
		loading: true
	});
};

/**
 * 用户认证资料变更提醒接口
 * @param context {Object} store实例
 * @param obj {Object} 对应参数
 */
export const fetchAuthChange = (context, obj) => {
	comeinFetch({
		constant_key: 'json_user_auth-change',
		body: {
			changeType: Number(obj.changeType),
			company: String(obj.company)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: code => {
			obj.error && obj.error(code);
		},
		loading: true
	});
};

/**
 * 用户认证资料变更弹框未变更操作接口
 * @param context {Object} store实例
 * @param obj {Object} 对应参数
 */
export const fetchNoChange = (context, obj) => {
	comeinFetch({
		constant_key: 'json_user_no-change',
		body: {
			remindType: Number(obj.remindType)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: code => {
			obj.error && obj.error(code);
		},
		loading: true
	});
};

/** app 上传图片 **/
export const getAppUploadImage = (ctx, cb) => {
	cmi.onCardImageUpload = res => {
		res = JSON.parse(res);
		if (!Number(res.code)) {
			cb && cb(res);
		}
	};

	webNative({
		method: 'cardImageUpload',
		param: {},
		callback: 'cmi.onCardImageUpload'
	});
};

/**
 * 点击统计
 * @param ctx
 * @param params
 */
export const statisticClick = (ctx, params) => {
	comeinFetch({
		constant_key: 'json_statistic_click',
		body: {
			...params
		},
		loading: false
	});
};

/**
 * 关注列表
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchEventAttentionList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_event_attlist',
		body: {
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 路演列表（研究） 替代原 fetchEventIndustry / json_event_industry 接口
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchRoadshowSearch = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_search',
		body: {
			industryTagIds: obj.industryTagIds || '',
			roadshowStatus: obj.roadshowStatus || '',
			roadshowInterval: obj.roadshowInterval || '',
			marketTagIds: obj.marketTagIds || '',
			roadshowTypeIds: obj.roadshowTypeIds || '',
			openStatusCodes: obj.openStatusCodes || '',
			topicIdsArr: obj.topicIdsArr || '',
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 *
 */
export const fetchRoadshowAnalyst = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_analyst',
		body: {
			industryTagIds: obj.industryTagIds || '',
			marketTagIds: obj.marketTagIds || '',
			roadshowTypeIds: obj.roadshowTypeIds || '',
			roadshowStatus: obj.roadshowStatus || '',
			roadshowInterval: obj.roadshowInterval || '',
			openStatusCodes: obj.openStatusCodes || '',
			topicIdsArr: obj.topicIdsArr || '',
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 *
 */
export const fetchRoadshowPublicCompany = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_public-company',
		body: {
			industryTagIds: obj.industryTagIds || '',
			marketTagIds: obj.marketTagIds || '',
			roadshowTypeIds: obj.roadshowTypeIds || '',
			roadshowStatus: obj.roadshowStatus || '',
			roadshowInterval: obj.roadshowInterval || '',
			openStatusCodes: obj.openStatusCodes || '',
			topicIdsArr: obj.topicIdsArr || '',
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

export const fetchRoadshowFinancial = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_financial',
		body: {
			bannerid: obj.bannerid,
			pagestart: obj.pagestart || '0',
			pagenum: obj.pagenum || '15'
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 分析师排行榜业绩榜数据
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchRankAnalystList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_rank_analystlist',
		body: {
			ranktype: obj.rankType
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 分析师收益信息
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchRecommendProfit = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_recommend_profit',
		body: {
			analystid: obj.analystid
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 分析师收益线图
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchRecommendProfitLine = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_recommend_profitline',
		body: {
			analystid: obj.analystid
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 分析师推荐股票
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchRecommendStocks = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_recommend_stocks',
		body: {
			analystid: obj.analystid,
			simple: obj.simple
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 分析师收益贡献比例
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchRecommendProfitScale = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_recommend_profitscale',
		body: {
			analystid: obj.analystid
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 调仓记录
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchRecommendRates = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_recommend_rates',
		body: {
			analystid: obj.analystid,
			stockid: obj.stockid,
			pagenum: obj.pagenum,
			pagestart: obj.pagestart
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 排序关注股票操作
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchSubscriptionSortstock = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_subscription_sortstock',
		body: {
			stockids: obj.stockids
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 批量取消关注股票操作
 * @param ctx {Object} store实例
 * @param obj {Object} 参数对象
 */
export const fetchSubscriptionBatchCancelStock = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_subscription_batchcancelstock',
		body: {
			stockids: obj.stockids
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

//获取投研活动签到详情
export const fetchEnrollmentSignUpDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'irm_register_info',
		body: {
			conferenceId: String(obj.id)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * 获取投研活动详情
 * http://yapi.comein.cn/project/106/interface/api/32108
 * **/
export const fetchEnrollmentDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_activity-detail',
		body: {
			activityId: String(obj.id)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false,
		keepAllLine: true
	});
};

//报名投研活动（旧
export const fetchEnrollmentRegister_old = (ctx, obj) => {
	comeinFetch({
		constant_key: 'irm_register_register',
		body: {
			conferenceId: String(obj.id),
			name: String(obj.name),
			company: String(obj.company),
			position: String(obj.occupation),
			identifyUrl: String(obj.bcard),
			institution: obj.institution
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

//报名投研活动（新
export const fetchEnrollmentRegister = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_activity-signup',
		body: {
			...obj,
			activityId: String(obj.id),
			uname: obj.name ? String(obj.name) : null,
			company: obj.company ? String(obj.company) : null,
			occupation: obj.occupation ? String(obj.occupation) : null,
			visitingCardUrl: obj.bcard ? String(obj.bcard) : null,
			userTypeId: obj.userinvesttype ? Number(obj.userinvesttype) : null,
			autographUrl: obj.autographUrl ? String(obj.autographUrl) : null,
			hasConfirm: obj.hasConfirm ? Number(obj.hasConfirm) : null,
			registerMode: obj.registerMode,
			idCard: obj.idCard || null
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (e, msg) => {
			obj.error && obj.error(e, msg);
		},
		loading: false
	});
};

//保存ocr识别后的名片信息
export const fetchOcrToSaveCard = (ctx, obj) => {
	comeinFetch({
		body: {
			...obj,
			// type
			phone: String(obj.phone),
			uid: Number(obj.uid),
			activityId: Number(obj.activityId),
			email: String(obj.email),
			company: String(obj.company),
			position: String(obj.position),
			address: String(obj.address)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (e, msg) => {
			obj.error && obj.error(e, msg);
		},
		loading: false
	});
};

//报名投研活动（登记报名
export const fetchEnrollmentRegisterSingleSign = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_activity-signup',
		body: {
			activityId: String(obj.id)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

// 投研活动签到
export const fetchEnrollmentSignIn = (ctx, obj) => {
	comeinFetch({
		constant_key: 'irm_register_checkin',
		body: {
			conferenceId: String(obj.id),
			location: obj.address,
			institution: obj.institution,
			company: obj.company,
			position: obj.position,
			name: obj.name,
			registerMode: obj.registerMode,
			userTypeId: obj.userinvesttype,
			visitingCardUrl: obj.visitingCardUrl,
			autographUrl: obj.autographUrl
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (e, msg) => {
			obj.error && obj.error(e, msg);
		},
		loading: false
	});
};

//报名投研活动（单页专题调研活动
export const fetchEnrollmentRegisterFromSinglePage = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_popularize_signup',
		code_8008: true,
		body: {
			...obj,
			activityId: String(obj.id),
			uname: obj.name ? String(obj.name) : null,
			company: obj.company ? String(obj.company) : null,
			occupation: obj.occupation ? String(obj.occupation) : null,
			visitingCardUrl: obj.bcard ? String(obj.bcard) : null,
			userTypeId: obj.userinvesttype ? Number(obj.userinvesttype) : null,
			idCard: obj.idCard || null
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: e => {
			obj.error && obj.error(e);
		},
		loading: false
	});
};

/**
 * 查询企业号详情
 * @param ctx
 * @param obj id        必填      组织ID
 * */
export const fetchIRStoreDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_info',
		body: {
			orgId: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/**
 * 关注企业号
 * @param ctx
 * @param obj id        必填      组织ID
 * */
export const fetchStoreSubscription = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_subscribe',
		body: {
			orgId: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/**
 * 查询企业号路演列表
 * @param ctx
 * @param obj id        必填      组织ID
 * @param obj pagenum   选填      页大小，默认 20
 * @param obj pagestart 选填      起始页，默认 0
 * */
export const fetchIRMTeanList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_teams',
		body: {
			orgId: obj.id,
			pagenum: obj.pagenum || 50,
			pagestart: obj.pagestart || 0
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/**
 * 查询企业号路演列表
 * @param ctx
 * @param obj id        必填      组织ID
 * @param obj pagenum   选填      页大小，默认 15
 * @param obj pagestart 选填      起始页，默认 0
 * */
export const fetchIRStoreRoadshowList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_roadshows',
		body: {
			orgId: obj.id,
			// pagenum: 3,
			pagenum: obj.pagenum || 15,
			pagestart: obj.pagestart || 0
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			}
		}
	});
};
/**
 * 查询企业号调研纪要列表
 * @param ctx
 * @param obj id        必填      组织ID
 * @param obj pagenum   选填      页大小，默认 15
 * @param obj pagestart 选填      起始页，默认 0
 * */
export const fetchIRStoreResearchLogs = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_summaries',
		body: {
			orgId: obj.id,
			pagenum: obj.pagenum || 20,
			pagestart: obj.pagestart || 0
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			}
		}
	});
};
/**
 * 查询企业号调研活动列表
 * @param ctx
 * @param obj id        必填      组织ID
 * @param obj pagenum   选填      页大小，默认 15
 * @param obj pagestart 选填      起始页，默认 0
 * */
export const fetchIRStoreResearchActivitys = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_research-activitys',
		body: {
			orgId: obj.id,
			pagenum: obj.pagenum || 20,
			pagestart: obj.pagestart || 0
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			}
		}
	});
};
/**
 * 查询企业号研究报告
 * title	否	string	标题
 * fullCodes	否	string	默认用户所在公司，否则为指定公司
 * startTime	是	string	开始时间
 * endTime	否	string	结束时间，默认当前时间
 * pagestart	否	int	开始页，默认0
 * pagenum	否	int	每页条数
 * */
export const fetchIRStoreReport = (ctx, obj) => {
	comeinFetch({
		constant_key: 'irm_seller_researchreport',
		body: {
			type: -1,
			fullCodes: obj.fullCodes,
			startTime: '852048000',
			pagenum: obj.pagenum || 20,
			pagestart: obj.pagestart || 0
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			}
		}
	});
};

/**
 * 查询企业号研究报告(新)
 * title	否	string	标题
 * fullCodes	否	string	默认用户所在公司，否则为指定公司
 * startTime	是	string	开始时间
 * endTime	否	string	结束时间，默认当前时间
 * pagestart	否	int	开始页，默认0
 * pagenum	否	int	每页条数
 * type 否 int 研报类型
 * */
export const fetchIRStoreReportNew = (ctx, obj) => {
	comeinFetch({
		constant_key: 'irm_seller_storereport',
		body: {
			fullCodes: obj.fullCodes,
			startTime: '852048000',
			pagenum: obj.pagenum || 20,
			pagestart: obj.pagestart || 0,
			type: obj.type,
			rating: obj.rating
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			if (obj.error) {
				obj.error(code, desc, extra);
			}
		}
	});
};

/**
 * 查询企业号公告列表
 */
export const fetchIRStoreNotice = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_annos',
		body: {
			orgId: obj.id,
			annoClassifId: obj.noticeType,
			pagestart: obj.pagestart || 0,
			pagenum: obj.pagenum || 10
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};
/**
 * 查询企业号公告类别
 */
export const fetchIRStoreNoticeType = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_annoclasses',
		body: {},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

/**
 * 查询公告文档链接
 */
export const fetchIRStoreNoticeLink = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_annolink',
		body: {
			id: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		error: (code, desc, extra) => {
			obj.error && obj.error(code, desc, extra);
		}
	});
};

/**
 * 查询企业号进行中活动
 * @param ctx
 * @param obj id        必填      组织ID
 * @param obj pagenum   选填      页大小，默认 15
 * @param obj pagestart 选填      起始页，默认 0
 * */
export const fetchIRStoreResearchAdv = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_research-activity',
		body: {
			orgId: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**
 * 查询企业号进行中活动
 * @param ctx
 * @param obj id        必填      组织ID
 * @param obj pagenum   选填      页大小，默认 15
 * @param obj pagestart 选填      起始页，默认 0
 * */
export const fetchIRStoreResearchLogDetail = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_summary_detail',
		body: {
			id: obj.id
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/**
 * 提交调研预约
 organizationId	是	int	调研公司ID
 researchOrganizationName	是	string	机构名称
 investTypeId	是	string	机构类型
 investTypeDescription	是	string	机构类型名称
 joinNumber	是	string	参加人数
 contact	是	string	联系人
 areaCode	是	string	国际代码
 phone	是	string	联系方式
 occupation	是	string	联系人职位
 businessCard	是	string	联系人明信片（上传后对应的name）
 researchTime	是	string	调研日期
 requestContent	是	string	调研内容
 * */
export const fetchResearchAppoint = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_research_ask',
		body: {
			organizationId: obj.organizationId,
			researchOrganizationName: obj.researchOrganizationName,
			investTypeId: obj.investTypeId,
			investTypeDescription: obj.investTypeDescription,
			joinNumber: obj.joinNumber,
			contact: obj.contact,
			areaCode: obj.areaCode || '+86',
			phone: obj.phone,
			occupation: obj.occupation,
			businessCard: obj.businessCard,
			researchTime: obj.researchTime,
			requestContent: obj.requestContent
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/**
 * 卖方研究趋势-研究报告下载
 reportId	是	int	研报ID
 * */
export const fetchIRStoreSellerReportDownload = (ctx, obj) => {
	comeinFetch({
		constant_key: 'irm_seller_reportdownload',
		body: {
			reportId: obj.id,
			type: obj.type
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**
 * 自定义菜单内容列表
 * @param ctx
 * @param obj title        选填     标题
 * @param obj bannerType   必填     菜单id
 * @param obj type         必填     栏目组类型，此处固定为3
 * @param obj platform     必填     平台标识，此处固定为0
 * @param obj pagestart    选填
 * @param obj pagenum      选填
 * */

export const fetchIRStoreCustomize = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_irstore_tabcontentlist',
		body: {
			title: obj.title,
			bannerType: obj.bannerType,
			orgId: obj.orgId,
			type: 3,
			platform: 0,
			pagestart: obj.pagestart,
			pagenum: obj.pagenum
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/** 观看历史列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchBannerHistory = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_watchlist-uc',
		body: {
			token: String(obj.token),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/** 我的关注列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchBannerAttention = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_analyst_sublist-uc',
		body: {
			token: String(obj.token),
			pagestart: String(obj.pagestart || 0),
			pagenum: String(obj.pagenum || 15)
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/** 我的报名列表
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchMyApplyList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_search-apply',
		body: {
			...obj
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/** 我的报名数据
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchMyApplyListCount = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow_search-apply-count',
		body: {
			...obj
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};
/** 删除我的报名数据
 *
 * @param ctx {String} store实例
 * @param obj {Object} 参数对象
 * @param obj.topicid {String} id
 */
export const fetchMyApplyListDetele = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_meetingactivity_hide',
		body: {
			...obj
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

export const fetchCalendarList = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_interest_calendar-list',
		body: {
			...obj
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

export const fetchCalendarCount = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_interest_calendar-count',
		body: {
			...obj
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		}
	});
};

/**
 * 行业路演列表
 */
export const fetchRoadshowIndustryId = (ctx, obj) => {
	comeinFetch({
		constant_key: 'json_roadshow-list_industry-id',
		body: {
			industryId: obj.industryId || 0,
			pagestart: obj.pagestart || 0,
			pagenum: obj.pagenum || 15,
			roadshowStatus: obj.roadshowStatus,
			topicIdsArr: obj.topicIdsArr || '',
			roadshowInterval: obj.roadshowInterval || '',
			title: obj.title || ''
		},
		success: (res, extra) => {
			obj.success && obj.success(res, extra);
		},
		loading: false
	});
};

/**
 * IR年度总结详情
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47705
 */
export const fetchAnnualShareDetail = (ctx, obj) => {
	Vue.axios
		.get(`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/detail?secretKey=${obj.secretKey}`)
		.then(res => {
			if (res.data.code == 0) {
				obj.success && obj.success(res.data.data);
			} else {
				obj.error && obj.error(null);
			}
		})
		.catch(err => {
			obj.error(err);
		});
};
/**
 * 公司券商评级总结
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47627
 */
export const fetchAnnualSummary = (ctx, obj) => {
	const { secretKey, success, error, ...params } = obj;
	let body = {
		'Content-Type': 'application/json;charset=utf-8'
	};
	Vue.axios
		.post(
			`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/summary?secretKey=${secretKey}`,
			{
				...params
			},
			{
				headers: body
			}
		)
		.then(res => {
			if (res.data.code == 0) {
				success && success(res.data.data);
			}
		})
		.catch(err => {
			error && error(err);
		});
};
/**
 * 公司券商评级目标价趋势
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47630
 */
export const fetchAnnualPriceTrend = (ctx, obj) => {
	const { secretKey, success, error, ...params } = obj;
	let body = {
		'Content-Type': 'application/json;charset=utf-8'
	};
	Vue.axios
		.post(
			`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/priceTrend?secretKey=${secretKey}`,
			{
				...params
			},
			{
				headers: body
			}
		)
		.then(res => {
			if (res.data.code == 0) {
				success && success(res.data.data);
			}
		})
		.catch(err => {
			error && error(err);
		});
};
/**
 * 信息披露
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47621
 */
export const fetchAnnualInformationDisclosure = (ctx, obj) => {
	Vue.axios
		.get(
			`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/information-disclosure?secretKey=${obj.secretKey}&startTime=${obj.startTime}&endTime=${obj.endTime}`
		)
		.then(res => {
			if (res.data.code == 0) {
				obj.success && obj.success(res.data.data);
			}
		})
		.catch(err => {
			obj.error(err);
		});
};
/**
 * 公司公告发布统计
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47624
 */
export const fetchAnnualAnnoList = (ctx, obj) => {
	const { secretKey, success, error, ...params } = obj;
	let body = {
		'Content-Type': 'application/json;charset=utf-8'
	};
	Vue.axios
		.post(
			`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/anno-list?secretKey=${secretKey}`,
			{
				...params
			},
			{
				headers: body
			}
		)
		.then(res => {
			if (res.data.code == 0) {
				success && success(res.data.rows);
			}
		})
		.catch(err => {
			error && error(err);
		});
};
/**
 * 互动平台
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47615
 */
export const fetchAnnualInteractivePlatform = (ctx, obj) => {
	Vue.axios
		.get(
			`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/interactive-platform?secretKey=${obj.secretKey}&startTime=${obj.startTime}&endTime=${obj.endTime}`
		)
		.then(res => {
			if (res.data.code == 0) {
				obj.success && obj.success(res.data.data);
			}
		})
		.catch(err => {
			obj.error(err);
		});
};
/**
 * 公司舆情-互动易标签舆情数量（含总数）
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47618
 */
export const fetchAnnualAdvisoryTagTotalCount = (ctx, obj) => {
	const { secretKey, success, error, ...params } = obj;
	let body = {
		'Content-Type': 'application/json;charset=utf-8'
	};
	Vue.axios
		.post(
			`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/advisory-tag-total-count?secretKey=${secretKey}`,
			{
				...params
			},
			{
				headers: body
			}
		)
		.then(res => {
			if (res.data.code == 0) {
				success && success(res.data.data);
			}
		})
		.catch(err => {
			error && error(err);
		});
};

/**
 * 市场表现-股价走势
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47639
 */
export const fetchStockPriceTrends = (ctx, obj) => {
	Vue.axios
		.get(
			`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/stock-price-trends?secretKey=${obj.secretKey}&startTime=${obj.startTime}&endTime=${obj.endTime}`
		)
		.then(res => {
			if (res.data.code == 0) {
				obj.success && obj.success(res.data.data);
			}
		});
};
/**
 * 沟通数量超过同行业公司的比例
 * @param {*} ctx
 * @param {*} obj
 * @see http://yapi.comein.cn/project/56/interface/api/47615
 */
export const fetchAnnualCommPercentage = (ctx, obj) => {
	Vue.axios
		.get(
			`${COMEINURL}/irmcenter/irm/annual-summary/h5/share/commPercentage?secretKey=${obj.secretKey}&commTotal=${obj.commTotal}&type=${obj.type}`
		)
		.then(res => {
			if (res.data.code == 0) {
				obj.success && obj.success(res.data.data);
			} else {
				obj.success && obj.success(0);
			}
		})
		.catch(err => {
			obj.error(err);
		});
};
